
export function downloadCsvFile (reportData: any, fileName: string): void {
  const csvData = new Blob([reportData], {type: "text/csv;charset=utf-8;"});
  let csvURL = null;
  if (navigator.msSaveBlob) {
    csvURL = navigator.msSaveBlob(csvData, fileName);
  } else {
    csvURL = window.URL.createObjectURL(csvData);
  }
  const tempLink = document.createElement("a");
  tempLink.href = csvURL;
  tempLink.setAttribute("download", fileName);
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  window.URL.revokeObjectURL(csvURL);
}
